import apiService from '@/services/apiService';

const actions = {
  getSops({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxelmarket/seller-sop/find-with-paging', payload)
        .then((response) => {
          commit('SET_SOPS', response.data.data.results);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getSop({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`paxelmarket/seller-sop/${payload}`)
        .then((response) => {
          commit('SET_SOP', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  orderSop({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`paxelmarket/seller-sop/${payload.id}/change-order`, payload.orderData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postSop({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxelmarket/seller-sop', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putSop({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`paxelmarket/seller-sop/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delSop({ commit }, payload) {
    return new Promise((resolve, reject) => {
    apiService.delete(`paxelmarket/seller-sop/${payload}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
    });
  },

};

export default actions;
